<template>
  <svg id="icon-cross" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-519.5-12.5h554v512h-554z"/>
      <path fill="currentColor" fill-rule="nonzero" d="M13.89 12.593a.917.917 0 1 1-1.297 1.296L10 11.296 7.407 13.89a.917.917 0 1 1-1.296-1.296L8.704 10 6.11 7.407a.917.917 0 0 1 1.296-1.296L10 8.704l2.593-2.593a.917.917 0 0 1 1.296 1.296L11.296 10l2.593 2.593z"/>
    </g>
  </svg>
</template>
